export enum DocumentRevisionType {
    INITIAL = "INITIAL",
    NORMAL = "NORMAL",
    QUICK = "QUICK",
}
